<p-table [value]="tableData">
  <ng-template pTemplate="body" let-data>
    <tr>
      <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0"
          [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
          [colSpan]="data?.titleColspan ? 2 : 1"
          [width]="titleColumnWidth">
        {{ data?.i18nTitleKey ? i18n.i18nLng()[data.i18nTitleKey] : data?.title }}
      </td>
      @switch (data?.valueType) {
        @case ('STATE') {
          <td class="flex gap-2 align-items-center">
            <sps-payment-status-tag [status]="data.value"></sps-payment-status-tag>
          </td>
        }
        @case ('ACTIVATIONSTATE') {
          <td class="flex gap-2 align-items-center">
            <sps-activation-status-tag [active]="data.value"></sps-activation-status-tag>
          </td>
        }
        @case ('PASSWORD') {
          <td class="flex gap-2 align-items-center">
            <sps-masked-password [password]="data.value"></sps-masked-password>
          </td>
        }
        @default {
          @if (!data?.titleColspan) {
            <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis"
                [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                [width]="valueColumnWidth">
              {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
            </td>
          }
        }
      }
    </tr>
  </ng-template>
</p-table>
